import { z } from 'zod';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { userSchema } from '../models';
import { usersListQuerySchema } from './list.schema';

export type UsersListQuery = {
  id?: number | number[];
  organization?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  isActive?: boolean;
  lastLogin?: string | null;
  groups?: number[];
  queues?: number[];
  deleted?: boolean;
  search?: string;
  ordering?: string;
} & PaginationQuery;

export const list = (query: UsersListQuery = {}) => {
  return {
    endpoint: `/users`,
    method: 'GET',
    responseSchema: listResponse(userSchema),
    query: { ...query, includeTotal: true },
    querySchema: usersListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
